import { render, staticRenderFns } from "./ImportacaoTabela.vue?vue&type=template&id=299d78d8&lang=html&"
import script from "./ImportacaoTabela.vue?vue&type=script&lang=js&"
export * from "./ImportacaoTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/importacao/ImportacaoTabela.vue
// module id = 1417
// module chunks = 28